const baseurl = "https://vivaprateadastore.vercel.app";

export default baseurl;